import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';
import DialogDetalheTitulo from './DialogDetalheTitulo';
import useSetParamsURL from '../../../../../lib/useSetParamsURL';

interface ModalContextType {
    openModal: (content: string) => void;
    closeModal: () => void
}

const ModalDetalheTituloPagarContext = createContext<ModalContextType | undefined>(undefined);

export const ModalDetalheTituloPagarProvider: React.FC<{ children: ReactNode }> = ({ children }) => {

    const { searchParams, clearSingleParamUrl } = useSetParamsURL();
    const codigo = searchParams.get('detalhe-titulo-pagar')

    const [isOpen, setIsOpen] = useState(Boolean(codigo));
    const [itemValue, setItemValue] = useState<string | null>(codigo);

    const openModal = (content: string) => {
        setItemValue(content);
        setIsOpen(true);
    };

    const closeModal = () => {
        setIsOpen(false);
        setItemValue(null);
        clearSingleParamUrl("detalhe-titulo-pagar")
    };

    useEffect(() => {
        if (codigo) setItemValue(codigo)
    }, [codigo])

    return (
        <ModalDetalheTituloPagarContext.Provider value={{ openModal, closeModal }}>
            {children}

            {
                (itemValue && isOpen) &&
                <DialogDetalheTitulo
                    open={isOpen}
                    value={itemValue}
                    handleClose={closeModal}
                />
            }
        </ModalDetalheTituloPagarContext.Provider>
    );
};

// Hook para usar o contexto
export const useModalDetalheTituloPagar = (): ModalContextType => {
    const context = useContext(ModalDetalheTituloPagarContext);
    if (!context) throw new Error('useModal must be used within a ModalProvider');
    return context;
};